import axios from 'axios';

// Use relative URL in production (served from same server), or explicit URL in development
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000');

const api = axios.create({
  baseURL: `${API_URL}${API_URL.startsWith('/') ? '' : '/api'}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token and language to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add language preference to query params
    const language = localStorage.getItem('i18nextLng') || 'en';
    // Always add language parameter (even for 'en') for consistency
    if (!config.params) {
      config.params = {};
    }
    if (!config.params.language) {
      config.params.language = language;
    }
    // Also set Accept-Language header
    config.headers['Accept-Language'] = language;
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login if it's a 401 (unauthorized), not 403 (forbidden)
    // 403 might be for premium access which should be handled by the component
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Only redirect if not already on login/register page
      if (!window.location.pathname.includes('/login') && !window.location.pathname.includes('/register')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

